import ExcelJS from "exceljs";
import { sectorArray } from "../../../../ArrivalOnboarding/ArrivalOnboarding";

const headings = [
  // "candidate_id",
  "passport_number",
  // "actual_profession",
  "flight_details",
  "batch_code",
  "country",
  "date_of_departure",
  "time_of_departure",
  "date_of_arrival",
  "time_of_arrival",
  "arrival_sector",
  "pickup_to_be_arranged",
  "project_incharge",
  //   "selection_grade",
  //   "basic",
  //   "food",
  //   "fixed_ot",
  //   "hra",
  //   "travel_allowance",
  //   "mobile_allowance",
  //   "air_ticket_allowance",
  //   "additional_ot",
  //   "other_allowance",
  //   "duty_hours",
  //   "fixed_ot_hours",
  //   "duration_of_contract",
  //   "probation_period",
  //   "passport_issue_date",
  //   "passport_expiry_date",
  //   "emergency_contact_person_in_home_country",
  //   "emergency_contact_number_in_home_country",
  //   "covid_vaccine",
  //   "blood_group",
  // "status",
  // "arrival_date",
  // "visa_block_number",
  // "visa_reference_number",
  // "visa_stamping_date",
  // "company_id",
  // "sponsor_id",
];

const candidates = [
  {
    passport_number: "VITAE NULLA ELIGENDI",
    actual_profession: "WAITER",
    flight_details: "AIR-INDIA-111",
    batch_code: "Batch Code",
    country: "INDIA",
    date_of_departure: "10-12-2023",
    time_of_departure: "22:12:00",
    date_of_arrival: "11-12-2023",
    time_of_arrival: "09:30:00",
    arrival_sector: "TEMPORE ALIAS DOLOR",
    pickup_to_be_arranged: "SLA",
    project_incharge: "Arun",
  },
];

export default function FlightDetailsExcel(filename, candidateData) {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Sheet1");

  const sectorArray = candidateData?.sector?.map((data) => data?.name);
  const actualProfessionArray = candidateData?.job_possition?.map(
    (data) => data?.name
  );

  const dropdownWorkSheet = workbook.addWorksheet("dropdown", {
    state: "hidden",
  });
  for (let i = 0; i < sectorArray?.length; i++) {
    const row = dropdownWorkSheet.getRow(i + 1);
    row.getCell("A").value = sectorArray[i];
  }
  for (let i = 0; i < actualProfessionArray?.length; i++) {
    const row = dropdownWorkSheet.getRow(i + 1);
    row.getCell("B").value = actualProfessionArray[i];
  }

  const sectorArrayFormula = [`"${sectorArray.toString()}"`];
  const actualProfessionFormula = [`"${actualProfessionArray.toString()}"`];

  const titleRow = sheet.getRow(1);
  titleRow.getCell(1).value = "sno.";
  for (let i = 0; i <= headings.length; i++) {
    titleRow.getCell(i + 1).style = {
      alignment: { horizontal: "center", vertical: "middle" },
      fill: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFFF00" }, // Yellow color in ARGB format
      },
      border: {
        top: { style: "thin", color: { argb: "FF000000" } }, // Black color
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      },
    };
    if (headings[i] == "job_position_name") {
      titleRow.getCell(i + 2).value = "ACTUAL PROFESSION";
    } else {
      titleRow.getCell(i + 2).value = headings[i];
    }

    const column = sheet.getColumn(i + 2);
    column.width = 24;
  }

  // Set header height
  sheet.getRow(1).height = 30;

  for (let i = 0; i < candidates?.length; i++) {
    const row = sheet.getRow(i + 2);
    row.getCell(1).value = i + 1;
    for (let j = 0; j < headings.length; j++) {
      if (headings[j] == "arrival_sector") {
        row.getCell(j + 2).value = sectorArray[0];
        row.getCell(j + 2).dataValidation = {
          type: "list",
          formulae:  [`"${sectorArray.toString()}"`],
          allowBlank: true,
          operator: "equal",
          promptTitle: "Select an option",
          prompt: headings[j],
        };
      // } else if (headings[j] == "actual_profession") {
      //   row.getCell(j + 2).value = actualProfessionArray[0];
      //   row.getCell(j + 2).dataValidation = {
      //     type: "list",
      //     formulae: [`dropdown!B1:B${actualProfessionArray.length}`],
      //     allowBlank: true,
      //     operator: "equal",
      //     promptTitle: "Select an option",
      //     prompt: headings[j],
      //   };
      }
      // else if (
      //   headings[j] == "date_of_departure" ||
      //   headings[j] == "date_of_arrival"
      // ) {
      //   row.getCell(j + 2).value = candidates[i][headings[j]] || "-";
      //   row.getCell(j + 2).dataValidation = {
      //     type: "date",
      //     // allowBlank: true,
      //     showErrorMessage: true,
      //     errorStyle: "error",
      //     formulae: [new Date()],
      //     error: "It should be a date.",
      //   };
      //   row.getCell(i + 2).numFmt = "dd/mm/yyyy";
      // }
      else {
        row.getCell(j + 2).value = candidates[i][headings[j]] || "-";
      }
    }
  }

  // Generate the Excel file and initiate download
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename ? `${filename}` : "Candidate Flight Detials";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    +URL.revokeObjectURL(url);
  });
}
